import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatProgressSpinnerModule],
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.scss'],
})
export class AppHeaderComponent {
  @Input() title: string | null = null;
  @Input() isRefreshing = false;
  /**
   * Keep the existing { icon, count$ } shape — resolving the observables would
   * churn internal-layout for no gain. Unused while isRefreshing is false.
   */
  @Input() syncIndicators: { icon: string; count$: Observable<string | null> }[] = [];
  @Input() cacheLastUpdated: string | null = null;
}
